import React from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { modePatternsStyle } from './style';
import { inputsStyle } from 'components/inputs/styles';
import { scheduleModalsStyle } from '../styles';
import { CustomNumericFormat } from '../../../../../components';
import { ErrorText } from '../../../../../utils';

export const DailyPattern = ({ handleChange, handleChangeDay, handleChangeConsecutive, inputs }) => {
    const classes = modePatternsStyle();
    const inputsClasses = inputsStyle();
    const datesAreNotMentioned = !inputs.startDate || !inputs.endDate;
    const countIsChecked = inputs.repeatCountCheckbox === 'repeatCountCheckbox';
    const consecIsChecked = inputs.repeatConsecutive === 'repeatConsecutive';

    const radioClasses = {
        root: inputsClasses.radio,
        checked: inputsClasses.checked,
    };

    return (
        <div style={datesAreNotMentioned ? { opacity: '0.5' } : {}}>
            <FormControl component="fieldset" style={{ width: '100%' }}>
                <RadioGroup
                    className={classes.formGroup}
                    // className={scheduleClasses.radioInputLabel}
                    style={{ display: 'flex', flexDirection: 'column' }}
                    onChange={handleChange}
                    row
                    aria-label="gender"
                    name="dailyPattern"
                >
                    <div className={classes.dailyBoxStyle}>
                        <FormControlLabel
                            onChange={handleChange}
                            name="repeatCountCheckbox"
                            className={inputsClasses.radioInputLabel}
                            value="repeatCountCheckbox"
                            label="Recur every"
                            control={<Radio disabled={datesAreNotMentioned} checked={countIsChecked} classes={radioClasses} />}
                            // disabled={datesAreNotMentioned}
                        />
                        <CustomNumericFormat
                            className={classes.smallInput}
                            name={'repeatCount'}
                            value={inputs?.repeatCount}
                            handleChangeMiles={(e) =>
                                handleChangeDay({
                                    target: {
                                        name: 'repeatCount',
                                        value: e.floatValue,
                                    },
                                })
                            }
                            noError={true}
                            disabled={datesAreNotMentioned || !countIsChecked}
                            decimalScale={0}
                        />
                        {/*<input*/}
                        {/*    type={'number'}*/}
                        {/*    value={inputs.repeatCount || ''}*/}
                        {/*    disabled={datesAreNotMentioned || !countIsChecked}*/}
                        {/*    name={'repeatCount'}*/}
                        {/*    onChange={handleChangeDay}*/}
                        {/*    className={classes.smallInput}*/}
                        {/*/>*/}
                        <span className={classes.days}>day(s)</span>
                    </div>
                    <div>
                        <FormControlLabel
                            onChange={handleChangeConsecutive}
                            name="repeatConsecutive"
                            className={inputsClasses.radioInputLabel}
                            value="repeatConsecutive"
                            label="every weekday"
                            control={<Radio disabled={datesAreNotMentioned} checked={consecIsChecked} classes={radioClasses} />}
                        />
                    </div>
                </RadioGroup>
            </FormControl>
        </div>
    );
};
